//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afghanistan",
  za: "Afrique du Sud",
  al: "Albanie",
  dz: "Algérie",
  de: "Allemagne",
  ad: "Andorre",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarctique",
  ag: "Antigua-et-Barbuda",
  sa: "Arabie saoudite",
  ar: "Argentine",
  am: "Arménie",
  aw: "Aruba",
  au: "Australie",
  at: "Autriche",
  az: "Azerbaïdjan",
  bs: "Bahamas",
  bh: "Bahreïn",
  bd: "Bangladesh",
  bb: "Barbade",
  be: "Belgique",
  bz: "Belize",
  bj: "Bénin",
  bm: "Bermudes",
  bt: "Bhoutan",
  by: "Biélorussie",
  bo: "Bolivie",
  ba: "Bosnie-Herzégovine",
  bw: "Botswana",
  br: "Brésil",
  bn: "Brunéi Darussalam",
  bg: "Bulgarie",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Cambodge",
  cm: "Cameroun",
  ca: "Canada",
  cv: "Cap-Vert",
  cl: "Chili",
  cn: "Chine",
  cy: "Chypre",
  co: "Colombie",
  km: "Comores",
  cg: "Congo-Brazzaville",
  cd: "Congo-Kinshasa",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  cr: "Costa Rica",
  ci: "Côte d’Ivoire",
  hr: "Croatie",
  cu: "Cuba",
  cw: "Curaçao",
  dk: "Danemark",
  dj: "Djibouti",
  dm: "Dominique",
  eg: "Égypte",
  ae: "Émirats arabes unis",
  ec: "Équateur",
  er: "Érythrée",
  es: "Espagne",
  ee: "Estonie",
  sz: "Eswatini",
  va: "État de la Cité du Vatican",
  fm: "États fédérés de Micronésie",
  us: "États-Unis",
  et: "Éthiopie",
  fj: "Fidji",
  fi: "Finlande",
  fr: "France",
  ga: "Gabon",
  gm: "Gambie",
  ge: "Géorgie",
  gs: "Géorgie du Sud et îles Sandwich du Sud",
  gh: "Ghana",
  gi: "Gibraltar",
  gr: "Grèce",
  gd: "Grenade",
  gl: "Groenland",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernesey",
  gn: "Guinée",
  gq: "Guinée équatoriale",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  gf: "Guyane française",
  ht: "Haïti",
  hn: "Honduras",
  hu: "Hongrie",
  bv: "Île Bouvet",
  cx: "Île Christmas",
  im: "Île de Man",
  nf: "Île Norfolk",
  ax: "Îles Åland",
  ky: "Îles Caïmans",
  cc: "Îles Cocos",
  ck: "Îles Cook",
  fo: "Îles Féroé",
  hm: "Îles Heard et McDonald",
  fk: "Îles Malouines",
  mp: "Îles Mariannes du Nord",
  mh: "Îles Marshall",
  um: "Îles mineures éloignées des États-Unis",
  pn: "Îles Pitcairn",
  sb: "Îles Salomon",
  tc: "Îles Turques-et-Caïques",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  in: "Inde",
  id: "Indonésie",
  iq: "Irak",
  ir: "Iran",
  ie: "Irlande",
  is: "Islande",
  il: "Israël",
  it: "Italie",
  jm: "Jamaïque",
  jp: "Japon",
  je: "Jersey",
  jo: "Jordanie",
  kz: "Kazakhstan",
  ke: "Kenya",
  kg: "Kirghizistan",
  ki: "Kiribati",
  kw: "Koweït",
  re: "La Réunion",
  la: "Laos",
  ls: "Lesotho",
  lv: "Lettonie",
  lb: "Liban",
  lr: "Libéria",
  ly: "Libye",
  li: "Liechtenstein",
  lt: "Lituanie",
  lu: "Luxembourg",
  mk: "Macédoine du Nord",
  mg: "Madagascar",
  my: "Malaisie",
  mw: "Malawi",
  mv: "Maldives",
  ml: "Mali",
  mt: "Malte",
  ma: "Maroc",
  mq: "Martinique",
  mu: "Maurice",
  mr: "Mauritanie",
  yt: "Mayotte",
  mx: "Mexique",
  md: "Moldavie",
  mc: "Monaco",
  mn: "Mongolie",
  me: "Monténégro",
  ms: "Montserrat",
  mz: "Mozambique",
  mm: "Myanmar (Birmanie)",
  na: "Namibie",
  nr: "Nauru",
  np: "Népal",
  ni: "Nicaragua",
  ne: "Niger",
  ng: "Nigéria",
  nu: "Niue",
  no: "Norvège",
  nc: "Nouvelle-Calédonie",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  ug: "Ouganda",
  uz: "Ouzbékistan",
  pk: "Pakistan",
  pw: "Palaos",
  pa: "Panama",
  pg: "Papouasie-Nouvelle-Guinée",
  py: "Paraguay",
  nl: "Pays-Bas",
  bq: "Pays-Bas caribéens",
  pe: "Pérou",
  ph: "Philippines",
  pl: "Pologne",
  pf: "Polynésie française",
  pr: "Porto Rico",
  pt: "Portugal",
  qa: "Qatar",
  hk: "R.A.S. chinoise de Hong Kong",
  mo: "R.A.S. chinoise de Macao",
  cf: "République centrafricaine",
  do: "République dominicaine",
  ro: "Roumanie",
  gb: "Royaume-Uni",
  ru: "Russie",
  rw: "Rwanda",
  eh: "Sahara occidental",
  bl: "Saint-Barthélemy",
  kn: "Saint-Christophe-et-Niévès",
  sm: "Saint-Marin",
  mf: "Saint-Martin",
  sx: "Saint-Martin (partie néerlandaise)",
  pm: "Saint-Pierre-et-Miquelon",
  vc: "Saint-Vincent-et-les-Grenadines",
  sh: "Sainte-Hélène",
  lc: "Sainte-Lucie",
  sv: "Salvador",
  ws: "Samoa",
  as: "Samoa américaines",
  st: "Sao Tomé-et-Principe",
  sn: "Sénégal",
  rs: "Serbie",
  sc: "Seychelles",
  sl: "Sierra Leone",
  sg: "Singapour",
  sk: "Slovaquie",
  si: "Slovénie",
  so: "Somalie",
  sd: "Soudan",
  ss: "Soudan du Sud",
  lk: "Sri Lanka",
  se: "Suède",
  ch: "Suisse",
  sr: "Suriname",
  sj: "Svalbard et Jan Mayen",
  sy: "Syrie",
  tj: "Tadjikistan",
  tw: "Taïwan",
  tz: "Tanzanie",
  td: "Tchad",
  cz: "Tchéquie",
  tf: "Terres australes françaises",
  io: "Territoire britannique de l’océan Indien",
  ps: "Territoires palestiniens",
  th: "Thaïlande",
  tl: "Timor oriental",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinité-et-Tobago",
  tn: "Tunisie",
  tm: "Turkménistan",
  tr: "Turquie",
  tv: "Tuvalu",
  ua: "Ukraine",
  uy: "Uruguay",
  vu: "Vanuatu",
  ve: "Venezuela",
  vn: "Vietnam",
  wf: "Wallis-et-Futuna",
  ye: "Yémen",
  zm: "Zambie",
  zw: "Zimbabwe",
};
